import { render, staticRenderFns } from "./foemifi.vue?vue&type=template&id=681dce80&"
import script from "./foemifi.vue?vue&type=script&lang=js&"
export * from "./foemifi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports